<template>

  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
    
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="名称" width="150">  </el-table-column>
           
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                 <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!-- <Add :open_add="open_add" v-if="open_add"  @close="closeAdd"></Add> -->
    <Edit :open_add="open_edit" :rule_type_id="rule_type_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  </div>
</template>

<script>
import projectApi from '@/api/project.js';
// import Add from './add.vue';
import Edit from './edit.vue';

export default {
  components: {
    // Add,
    Edit,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        status:"",
        title:"",
        type:""
      },
      status: ['未审核','审核通过', '审核不通过'],

      open_add:false,
      open_edit:false,
      rule_type_id:"",

    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
          /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
        /*添加任务*/
        addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
 
        this.rule_type_id = row.rule_type_id;
        this.open_edit = true
      },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      projectApi.typeList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },


    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          projectApi.delType(
            {
              rule_type_id: row.rule_type_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },


  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/project/type/index.vue